<template>
    <div>
        <el-form :model="orderServcEval" ref="evalInfo" class="demo-ruleForm">
            <div class="serv-evaluation">
                <div class="title">
                    <p class="mb10">评价服务</p>
                </div>
                <div class="content">
                    <div class="column-layout serv-evaluation clearfix">
                        <div class="left-column fl">
                            <p>主工程师：{{servcWorkVoucher.engineerName || '无'}}</p>
                        </div>
                        <div class="right-column fl">
                            <div class="simple-form">
                                <div class="form-group center">
                                    <div class="form-label">
                                        <label class="required">服务态度</label>
                                    </div>
                                    <div class="form-value width-1-5x">
                                        <el-form-item prop="attitudeScore">
                                            <el-rate v-model="orderServcEval.attitudeScore"></el-rate>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group center">
                                    <div class="form-label">
                                        <label class="required">服务技能</label>
                                    </div>
                                    <div class="form-value width-1-5x">
                                        <el-form-item prop="skillsScore">
                                            <el-rate v-model="orderServcEval.skillsScore"></el-rate>
                                        </el-form-item>
                                    </div>
                                </div>
                                <div class="form-group center">
                                    <div class="form-label">
                                        <label class="required">服务质量</label>
                                    </div>
                                    <div class="form-value width-1-5x">
                                        <el-form-item prop="qualityScore">
                                            <el-rate v-model="orderServcEval.qualityScore"></el-rate>
                                        </el-form-item>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="column-layout serv-evaluation clearfix mt30">
                        <div class="left-column fl">
                            <img :src="servcOrderItem.servcFileBrowseUrl" style="width: 200px; height: 150px"/>
                            <p class="mt10">{{servcOrderItem.title}}</p>
                        </div>
                        <div class="right-column fl">
                            <div class="simple-form">
                                <div class="form-group center">
                                    <div class="form-label">
                                        <label>评价标签</label>
                                    </div>
                                    <div class="form-value width-3x">
                                        <ul class="enum-list clearfix">
                                            <li v-for="item in tags" :class="checkedSelect(item.id) ? 'enum-item checked' : 'enum-item'" @click="select(item)">
                                                {{item.name}}<i></i>
                                            </li>
                                        </ul>
                                    </div>
                                </div>
                                <div class="form-group center">
                                    <div class="form-label">
                                        <label>评论内容</label>
                                    </div>
                                    <div class="form-value">
                                        <textarea v-model="orderServcEval.comment" class="width-3x"></textarea>
                                    </div>
                                </div>
                                <!-- 上传附件 -->
                                <div class="form-group center">
                                    <div class="form-label" >
                                        <label>上传图片</label>
                                    </div>
                                    <div class="form-value width-3x">
                                        <div class="mt5">
                                            <swb-file-upload :fileFor="'solution'" fileGroup="file-misc" :onBeforeUpload="onBeforeUpload" :onProgress="onProgress" :onDone="onUploadDone" :multipleFile="true"></swb-file-upload>
                                            <div class="file-area clearfix">
                                                <div class="mr15 inline-block" v-for="(evalFile, index) in evalFileList">
                                                    <div class="file-item show-usage image deletable viewable downloadable editable" v-if="evalFile.fileExtName == 'jpg' || evalFile.fileExtName == 'png' || evalFile.fileExtName == 'jpeg'|| evalFile.fileExtName == 'JPEG'">
                                                        <div class="file-content">
                                                            <div class="usage ellipsis-1">{{evalFile.fileName}}</div>
                                                            <img :src="evalFile.fileBrowseUrl"/>
                                                            <div class="operation-group">
                                                                <i class="icon iconfont icon-chakan view" @click="viewImage(evalFile.fileBrowseUrl)"></i>
                                                            </div>
                                                            <div class="delete-icon" @click="removeUpload(index)"></div>
                                                        </div>
                                                    </div>
                                                    <div class="file-item show-usage deletable viewable downloadable editable" v-else>
                                                        <div class="file-content">
                                                            <div class="usage ellipsis-1">{{evalFile.fileName}}</div>
                                                            <img :src="evalFile.fileBrowseUrl"/>
                                                            <div class="operation-group">
                                                                <i class="icon iconfont icon-xiazai download" @click="downloadFile(evalFile.fileUuid);"></i>
                                                            </div>
                                                            <div class="delete-icon" @click="removeUpload(index)"></div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </el-form>
    </div>
</template>
<script>
    import { Utils } from '../../app.base'
    import { Vue, Routes, MsgBox } from '../../app.vues'

    import servcDelivApi from '../../api/servcDeliv';
    import servcCategApi from '../../api/servcCateg';

    export default {
        name: 'swb-order-servc-eval',
        desc: '服务评价',
        props: ['workId'],
        data: function () {
            let checkNull = function (rule, value, callback) {
                if(Utils.isNoB(value)) {
                    callback(new Error('不能为空'));
                } else {
                    if(value == 0) {
                        callback(new Error('请评分'));
                    } else {
                        callback();
                    }
                }
            };
            return {
                servcWorkVoucher: {},
                servcOrderItem: {},
                orderServcEval: {
                    workVoucherId: null,
                    attitudeScore: 0,
                    skillsScore: 0,
                    qualityScore: 0
                    //servcScore: 1
                },
                evalFileList: [],
                tags: [],
                tagIds: [],
                theLoading: null,
                rules: {
                    attitudeScore: [
                        {validator: checkNull, trigger: 'blur'}
                    ],
                    skillsScore: [
                        {validator: checkNull, trigger: 'blur'}
                    ],
                    qualityScore: [
                        {validator: checkNull, trigger: 'blur'}
                    ]
//                    servcScore: [
//                        {validator: checkNull, trigger: 'blur'}
//                    ]
                }
            }
        },
        created: function () {
            this.getServcWorkVoucherDetail();
            this.getServcOrderItemByServcWorkVoucherId();
        },
        methods: {
            getServcWorkVoucherDetail(){
                let self = this;
                let postData = {};
                postData.id = self.workId;
                servcDelivApi.getServcWorkVoucherDetail(postData, function (result) {
                    if(result.type == 'info') {
                        self.servcWorkVoucher = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getServcOrderItemByServcWorkVoucherId(){
                let self = this;
                let postData = {};
                postData.workId = this.workId;
                self.theLoading = MsgBox.loading();
                servcDelivApi.getServcOrderItemByServcWorkVoucherId(postData, function (result) {
                    if(result.type == 'info') {
                        self.servcOrderItem = result.data;
                        // 获取标签
                        self.getOrderServcEvalTags();
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            getOrderServcEvalTags: function () {
                let self = this;
                let postData = {};
                postData.catId = self.servcOrderItem.catId;
                //
                console.log(self.servcOrderItem);
                servcCategApi.getServcCatEvalTagList(postData, function (result) {
                    self.theLoading.close();
                    if(result.type == 'info') {
                        self.tags = result.data;
                    } else {
                        MsgBox.warning(result.message);
                    }
                });
            },
            select(tag){
                let self = this;
                let index = self.checkedSelect(tag.id);
                if(!index) {
                    self.tagIds.push(tag);
                } else {
                    self.tagIds.remove(tag);
                }
            },
            checkedSelect(tagId){
                let self = this;
                for(let i = 0; i < self.tagIds.length; i++) {
                    if(self.tagIds[i].id === tagId) {
                        return true;
                    }
                }
                return false;
            },
            //
            onBeforeUpload: function (fileItems, uploader) {
                if(fileItems.length === 0) {
                    this.$message.error('请选择要上传的文件!');
                    return false;
                }
            },
            onProgress: function (progress) {
                let self = this;
                self.percentage = Math.floor((progress.loaded / progress.total) * 100);
            },
            //
            onUploadDone: function (result) {
                let self = this;
                if(result.type === 'info') {
                    let files = result.data.files;
                    for(let i = 0; i < files.length; i++) {
                        let file = files[i];
                        if(file.fileExtName == 'jpg' || file.fileExtName == 'png' || file.fileExtName == 'JPEG' || file.fileExtName == 'jpeg') {
                            self.evalFileList.push(file);
                        } else {
                            MsgBox.warning('支持 jpg、png、jpeg 图片格式！')
                        }
                    }
                } else {
                    this.$message.success(result.message);
                }
            },
            getDlgResult(){
                let self = this;
                let result = {};
                self.orderServcEval.workVoucherId = self.workId; // 工单id
                self.orderServcEval.orderServcEvalFileList = self.evalFileList; // 附件
                self.orderServcEval.servcCatEvalTags = self.tagIds; // 标签
                this.$refs['evalInfo'].validate(function (valid) {
                    if(valid) {
                        result.type = 'info';
                        result.data = self.orderServcEval;
                    } else {
                        result.type = "warn";
                        result.message = "校验失败";
                    }
                });
                return result;
            }
        }
    }
</script>



// WEBPACK FOOTER //
// src/compo/workVoucher/OrderServcEval.vue